import VFormBase from "../components/shared/vFormBase.vue";
import UserSelector from "../components/shared/UserSelector.vue";
import FloorPlan from "../components/shared/FloorPlan.vue";
import MyFeatures from "../components/shared/MyFeatures.vue";

export const dialogsMixin = {
  props: { editedItem: Object, mode: Object },
  components: { VFormBase, UserSelector, FloorPlan, MyFeatures },
  data() {
    return {
      required: msg => v => !!v || msg,
      minLen: l => v => (v && v.length >= l) || `min. ${l} Characters`,
      maxLen: l => v => (v && v.length <= l) || `max. ${l} Characters`,
      isDirty: false,
    };
  },
  computed: {
    baseSchema() {
      return {
        id: { type: "text", hidden: true },
        createdBy: { type: "text", hidden: true },
        createdTS: { type: "text", hidden: true },
        lastUpdatedBy: { type: "text", hidden: true },
        lastUpdatedTS: { type: "text", hidden: true }
      };
    }
  },
  methods: {
    alert(msg) {
      alert("From dialogsMixin: " + msg);
    },
    formTitle(docName) {
      return `${this.editedItem.id ? 'Edit' : 'New'} ${docName}`
    },
    onFormInput(event) {
      this.isDirty = true;
      return event;
    },
    async cancel(dialogStr) {
      if (
        !this.isDirty ||
        (await this.$confirm("Are you sure you want to cancel without save?"))
      ) {
        this.mode[dialogStr] = false;
      }
    },
    async deleteItem(dialogKey) {
      const payLoad = {
        collectionName: this.collectionName,
        docId: this.editedItem.id
      };
      if (
        !this.isDirty &&
        (await this.$confirm("Are you sure you want to delete this record?"))
      ) {
        this.$emit("delete", payLoad);
        this.mode[dialogKey] = false;
      }
    },
    async deActivate(dialogKey) {
      if (
        (await this.$confirm("Are you sure you want to deactivate this record?"))
      ) {
        this.editedItem.status = this.STATUSES.INACTIVE;
        this.save(dialogKey);
      }
    },
    save(dialogKey) {
      const payLoad = {
        collectionName: this.collectionName,
        docId: this.editedItem.id,
        doc: this.editedItem
      };
      this.$emit("save", payLoad);
      if (dialogKey) this.mode[dialogKey] = false;
    },
    async saveSync() {
      const payLoad = {
        collectionName: this.collectionName,
        docId: this.editedItem.id,
        doc: this.editedItem
      };
      await this.updateDocSync(payLoad);
      const doc = await this.readDocByIdSync(payLoad);
      return doc;
    }
  }
}